import styled from "styled-components";

export const MainDiv = styled.div`
  color: #2b3445;
  padding: 1.75rem 2rem 2rem 2rem;
`;

export const ProfileDiv = styled.div`
  background-color: #ffffff;
  border-radius: 2px;
  box-shadow: #000000 0px 1px 2px 0px;
  line-height: 24px;
  padding: 12px 12px 12px 22px;
  @media print {
    display: none;
  }
`;
export const AboutDiv = styled.div`
  align-items: center;
  color: #3490dc;
  display: flex;
  font-weight: 600;
  line-height: 32px;
`;

export const MainContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1rem;
`;
export const InformationContainer = styled.div`
  display: grid;
  margin-bottom: 1rem;
`;
export const InformationHeading = styled.div`
  color: black;
  font-size: 14px;
  text-transform: uppercase;
  font-weight: 500;
  padding-left: 16px;
`;

export const InformationDiv = styled.div`
  color: #797d85;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  margin-top: 5px;
  padding-left: 16px;
`;
export const AttachmentInformationDiv = styled.div`
  color: #797d85;
  font-size: 14px;
  font-weight: 600;
  padding-left: 16px;
`;
